import React from 'react'
// import { useLocation } from "react-router-dom"

export default () => {
  // Ideally use useLocation, but tests are failing with:
  // Error: useLocation() may be used only in the context of a <Router> component.
  // const { search } = useLocation()
  const search = window?.location?.search
  return React.useMemo(() => new URLSearchParams(search), [search])
}
